import { ID, Currency } from './common';
import { Pago } from './pago';
import { Contrato } from './contrato';
import { Usuario } from './usuario';
import { CfeDocument } from './cfe';

export const EstadoRecibo = {
  ACTIVO: 'ACTIVO',
  CANCELADO: 'CANCELADO',
} as const;
export type EstadoRecibo = typeof EstadoRecibo[keyof typeof EstadoRecibo];

export const TipoPagoRecibo = {
  INQUILINO: 'INQUILINO',
  PROPIETARIO: 'PROPIETARIO',
} as const;
export type TipoPagoRecibo = typeof TipoPagoRecibo[keyof typeof TipoPagoRecibo];

export interface Recibo {
  id: ID;
  numero_recibo: string; // Format: REC-YYYYMMDD-NNNNNN
  pago_id: ID;
  contrato_id: ID;
  propietario_id?: ID | null; // Specific owner for PROPIETARIO receipts
  monto_recibo: number; // INQUILINO: with extra costs, PROPIETARIO: net after deductions
  monto_total_pago: number;
  monto_aplicado_pago?: number; // Amount applied to pago debt (may differ from monto_recibo)
  moneda: Currency;
  estado: EstadoRecibo;
  fecha_emision: string; // YYYY-MM-DD HH:MM:SS
  fecha_cancelacion?: string | null; // YYYY-MM-DD HH:MM:SS
  motivo_cancelacion?: string | null;
  metodo_pago?: string | null;
  tipo_pago: TipoPagoRecibo;
  resguardo_confirmado?: boolean;
  resguardo_numero?: string | null;
  desglose?: string | null; // JSON string with cost breakdown
  emitido_por: ID;
  cancelado_por?: ID | null;
  created_at?: string;
  updated_at?: string;
  // Enriched fields returned by the paginated receipt list API
  numero_contrato?: string | null;
  inquilino_nombre?: string | null;
  propietario_nombre?: string | null;
  alquiler?: number;
  alquiler_reconstruido?: number | null;
  irpf_retenido_aparte?: boolean;
  neto_despues_retencion?: number | null;
  comision?: number | null;
  interes?: number;
  iva?: number | null;
  propietario_monto?: number | null;
  propietario_moneda?: Currency | null;
  impuestos?: number | null;
  importe?: number | null;
  // Nested objects populated by API
  pago?: Pago;
  contrato?: Contrato;
  usuario_emisor?: Usuario;
  usuario_cancelador?: Usuario;
  // CFE documents (populated when fetching status)
  cfe_documents?: CfeDocument[];
}

export interface ReciboSearchFilters {
  q?: string;
  contrato_id?: ID;
  pago_id?: ID;
  numero_recibo?: string;
  metodo_pago?: string;
  monto_recibo?: number;
  estado?: EstadoRecibo;
  tipo_pago?: TipoPagoRecibo;
  fecha_desde?: string; // YYYY-MM-DD
  fecha_hasta?: string; // YYYY-MM-DD
  fecha?: string; // Exact local calendar date, YYYY-MM-DD
  page?: number;
  limit?: number;
}

export interface ReciboCreateData {
  pago_id: ID;
  monto_recibo: number;
  metodo_pago?: string;
  resguardo_confirmado?: boolean;
  resguardo_numero?: string | null;
}

export interface ReciboBatchItem {
  propietario_id: ID;
  monto_recibo: number;
  monto_aplicado_pago: number;
  desglose: {
    valor_alquiler: number;
    comision_administracion: number;
    iva_comision: number;
    retencion_irpf: number;
    retencion_irpf_inquilino?: number;
    interes_mora?: number;
    iva_interes?: number;
    otros_importes?: Array<{ descripcion: string; valor: number }>;
  };
  resguardo_confirmado?: boolean;
  resguardo_numero?: string | null;
}

export interface ReciboBatchCreateData {
  pago_id: ID;
  metodo_pago: string;
  recibos: ReciboBatchItem[];
}

export interface ReciboCancelData {
  motivo: string;
}
